import React, { useContext, memo } from 'react';
import { TabContext } from './Tabs';

interface ScrollableTabPanelProps {
  index: number;
  children: React.ReactNode;
}

const ScrollableTabPanel: React.FC<ScrollableTabPanelProps> = memo(({ index, children }) => {
  const context = useContext(TabContext);

  if (!context) {
    throw new Error('ScrollableTabPanel must be used within a Tabs component.');
  }

  const { activeIndex } = context;

  return activeIndex === index ? (
    <div className="flex-grow overflow-hidden">
      <div
        id="tab-panel"
        className="h-full overflow-auto rounded-xl bg-neutral-200"
      >
        {children}
      </div>
    </div>
  ) : null;
});

export default ScrollableTabPanel;
